export const SUCCESS = "SUCCESS_TRACKER";
export const ERROR = "ERROR_TRACKER";
export const CLEAR = "CLEAR_TRACKER";
export const LOADING = "LOADING_TRACKER";

export const GET_STATUS = "GET_STATUS";
export const GET_POSITIONS = "GET_POSITIONS";

export function loading(loading = true) {
	return {
		type: LOADING,
		data: loading
	};
}

export function error(error) {
	return {
		type: ERROR,
		data: error
	};
}


export function success() {
	return {
		type: SUCCESS,
	};
}

export function clear() {
	return {
		type: CLEAR
	};
}

export function getStatusCreator(status) {
	return {
		type: GET_STATUS,
		data: status
	};
}
export function getPositionsCreator(device, positions) {
	return {
		type: GET_POSITIONS,
		data: {positions, device}
	};
}